import { render } from "./RegistrationForm.vue?vue&type=template&id=61283cfe&scoped=true&ts=true"
import script from "./RegistrationForm.vue?vue&type=script&lang=ts"
export * from "./RegistrationForm.vue?vue&type=script&lang=ts"

import "./RegistrationForm.vue?vue&type=style&index=0&id=61283cfe&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61283cfe"]])

export default __exports__